import(/* webpackMode: "eager", webpackExports: ["SignUpView"] */ "/vercel/path0/src/domains/auth/components/view/sign-up-view.tsx");
